import React from 'react'
import { useQuery } from '@apollo/client'
import { Redirect } from 'react-router-dom'

import { getCookie, hasCookie, deleteCookie } from '../utils/cookie'
import { GET_USER } from '../graphql/user'
import { LOGIN } from '../routes'

export const UserContext = React.createContext()

export default function UserProvider({ children }) {
  const { loading, data } = useQuery(GET_USER, {
    variables: { user: getCookie('user') },
  })

  if (!hasCookie('token')) {
    return <Redirect to={LOGIN} />
  }

  if (loading) {
    return null
  }

  function logout() {
    deleteCookie('user', '/', window.location.hostname)
    deleteCookie('token', '/', window.location.hostname)
    deleteCookie('merchant', '/', window.location.hostname)
  }

  return (
    <UserContext.Provider value={{ data, logout }}>
      {children}
    </UserContext.Provider>
  )
}
